"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listYears = void 0;
var datePart_1 = require("./datePart");
/**
 * Zwraca tablicę zawierającą listę lat pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 */
function listYears(startDate, endDate) {
    var y1 = (0, datePart_1.default)(startDate, 'y');
    var y2 = (0, datePart_1.default)(endDate, 'y');
    var result = [];
    if (y1 && y2) {
        //datePart przy nieprawidłowej dacie zwraca 0
        while (y1 <= y2) {
            result.push(y1);
            y1++;
        }
    }
    return result;
}
exports.listYears = listYears;
exports.default = listYears;
//# sourceMappingURL=listYears.js.map